import { t } from '@lingui/core/macro';
import { BackButton } from 'components/BackButton/BackButton';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { InnerLayout } from 'components/Layout/InnerLayout/InnerLayout';
import { SideNavigation } from 'components/Navigation/SideNavigation';
import { useRouterApplicationId } from 'components/Signup/hooks/useRouterApplicationId';
import { StepValidator } from 'components/Signup/StepValidator/StepValidator';
import { useOffersTabs } from 'components/Signup/TradingHistory/helpers/useOffersTabs.hook';
import { InstantOfferButton } from 'components/Signup/TradingHistory/InstantOfferButton/InstantOfferButton';
import { OffersTabs } from 'components/Signup/TradingHistory/OffersTabs/OffersTabs';
import { ScrollToDocumentUploadButton } from 'components/Signup/TradingHistory/ScrollToDocumentUploadButton/ScrollToDocumentUploadButton';
import { TradingHistory } from 'components/Signup/TradingHistory/TradingHistory';
import { TradingHistoryDE } from 'components/Signup/TradingHistory/TradingHistoryDE/TradingHistoryDE';
import { useAmplitude } from 'hooks/useAmplitude';
import { useLocale } from 'hooks/useLocale';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { BREAK_S } from 'utils/breakpoints';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './tradingHistory.module.css';

export const TradingHistoryPage = () => {
  const { isDE } = useLocale();
  const applicationId = useRouterApplicationId();
  const { trackEvent } = useAmplitude();
  const { currentView, indicativeOffer, instantOffer, handleTabChange } =
    useOffersTabs();
  const { width } = useWindowDimensions();
  const isMobile = width <= BREAK_S;

  const handleDocsBackTracking = () => {
    trackEvent(AMPLITUDE_EVENTS.backCTAClicked);
  };

  const backURL = PATH_NAMES.newApplicationStep1({ applicationId });

  return (
    <BaseLayout
      pageTitle={t`New Documents | Introducer Portal`}
      contentPadding={false}
    >
      <SideNavigation />
      <StepValidator>
        <InnerLayout
          hasSidebar
          className={styles.layout}
          contentClassName={styles.mainContent}
        >
          {!isDE && (
            <BackButton href={backURL} onClick={handleDocsBackTracking} />
          )}

          {isDE ? (
            <TradingHistoryDE
              backButton={
                <BackButton href={backURL} onClick={handleDocsBackTracking} />
              }
            />
          ) : (
            <div className={styles.ukTradingHistory}>
              {indicativeOffer && (
                <OffersTabs
                  indicativeOffer={indicativeOffer}
                  instantOffer={instantOffer}
                  handleTabChange={handleTabChange}
                  currentView={currentView}
                />
              )}

              {currentView === 'documentUpload' ? (
                <TradingHistory showTitle={!indicativeOffer} />
              ) : (
                <InstantOfferButton />
              )}
              {isMobile && <ScrollToDocumentUploadButton />}
            </div>
          )}
        </InnerLayout>
      </StepValidator>
    </BaseLayout>
  );
};
